// Generated by ReScript, PLEASE EDIT WITH CARE


var Rest;

var startDateTooLow = {
  id: "1cd5e9c6-4700-4eb4-aa3a-05c8f40702ef",
  defaultMessage: "Start date is too low"
};

var endDateTooHigh = {
  id: "aed1afa5-09a2-4433-9ae8-5ea13585b9b2",
  defaultMessage: "End date too high"
};

var datesNotSameYear = {
  id: "1c883d54-9d34-4db6-af81-486ef8d1aee1",
  defaultMessage: "Dates must be in the same year"
};

var dateOutOfPeriod = {
  id: "3721752a-7ff0-4d6f-94d1-c04b21cc87a2",
  defaultMessage: "Date out of allowed period"
};

var datesHaveIssue = {
  id: "50b27b21-2292-4849-8dee-7e6f7b4c5c9d",
  defaultMessage: "Invalid date"
};

var largerZero = {
  id: "3c41364d-30d7-45ee-9c3c-b3bdde1abd0f",
  defaultMessage: "Needs to be larger than zero"
};

var dateTooSmall = {
  id: "db8d07be-4860-4852-b583-759d96d9d042",
  defaultMessage: "Must be later than the other date"
};

var dateTooLarge = {
  id: "874d6eb2-5ddf-4381-8345-65896c902faf",
  defaultMessage: "Must be before the other date"
};

var otherDateNotValid = {
  id: "3b7a042c-923e-4617-9b8a-4e14397c4f35",
  defaultMessage: "Other date not valid"
};

var fieldRequired = {
  id: "5de13793-84d3-4f24-b0bf-f8b2d7f365a0",
  defaultMessage: "This field is required"
};

var fieldPositive = {
  id: "88ab4864-f801-4465-b647-8b296c270ec3",
  defaultMessage: "The number must be positive"
};

var fieldNegative = {
  id: "00478c17-da49-4718-bbf6-810b0f58b748",
  defaultMessage: "Number should be positive"
};

var invalidField = {
  id: "45794ba0-1735-472f-a47a-2b8347f964d3",
  defaultMessage: "Value not valid"
};

var sirenNotFound = {
  id: "159d8904-50c3-4741-b784-021db2367ce2",
  defaultMessage: "Company not found"
};

var listTooLong = {
  id: "bca32848-e621-494a-84ef-6d1e0f68adff",
  defaultMessage: "Selection has too many items"
};

var fieldLessCharactersThanMinimum = {
  id: "381f17a6-9df3-4455-899d-93ee1e3cf64b",
  defaultMessage: "The field is too short"
};

var fieldMoreCharactersThanMaximum = {
  id: "32035977-e482-4799-82af-289a323d2870",
  defaultMessage: "The field is too long"
};

var otherValueNotValid = {
  id: "5c78aa8b-60ac-475d-adc4-ae9a06e23f05",
  defaultMessage: "Other invalid value"
};

export {
  Rest ,
  startDateTooLow ,
  endDateTooHigh ,
  datesNotSameYear ,
  dateOutOfPeriod ,
  datesHaveIssue ,
  largerZero ,
  dateTooSmall ,
  dateTooLarge ,
  otherDateNotValid ,
  fieldRequired ,
  fieldPositive ,
  fieldNegative ,
  invalidField ,
  sirenNotFound ,
  listTooLong ,
  fieldLessCharactersThanMinimum ,
  fieldMoreCharactersThanMaximum ,
  otherValueNotValid ,
}
/* No side effect */
